import { SetStateAction, useState } from 'react';

export type UseFormStateReturn<T> = [
	boolean,
	(state: SetStateAction<boolean>) => void,
	T,
	(state: SetStateAction<T>) => void,
	T,
	(state: SetStateAction<T>) => void,
];

export const useFormState = <T>(initialState: T): UseFormStateReturn<T> => {
	const [editedForm, setEditedForm] = useState<boolean>(false);
	const [formData, setFormData] = useState<T>(initialState);
	const [formErrors, setFormErrors] = useState<T>({} as T);

	return [
		editedForm,
		setEditedForm,
		formData,
		setFormData,
		formErrors,
		setFormErrors,
	];
};

export default useFormState;
